export function alphaNumberOnly(e: any) {  // Accept only characters
	const regex = new RegExp("^[a-zA-Z ]*$");
	const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
	if (regex.test(str)) {
		return true;
	}
	e.preventDefault();
	return false;
}

export function alphaNumberPasteOnly(e: ClipboardEvent) {  // Accept only characters
	const regex = new RegExp("^[a-zA-Z ]*$");
	const clipboardData = e.clipboardData;
	const str = clipboardData!.getData("text");
	if (regex.test(str)) {
		return true;
	}
	e.preventDefault();
	return false;
}

export function numberOnly(e: any) {  // Accept only numerics
	const regex = new RegExp("^[0-9]*$");
	const str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
	if (regex.test(str)) {
		return true;
	}
	e.preventDefault();
	return false;
}

export function numberPasteOnly(e: any) {  // Accept only numerics
	const regex = new RegExp("^[0-9]*$");
	const clipboardData = e.clipboardData;
	const str = clipboardData!.getData("text");
	if (regex.test(str)) {
		return true;
	}
	e.preventDefault();
	return false;
}

const errorMap: Map<number, string> = new Map<number, string>([
  [400, 'backend_error.internal_error'],
  [404, 'backend_error.internal_error'],
  [500, 'backend_error.internal_error'],
  [4001, 'backend_error.email_already_used'],
  [4002, 'backend_error.phone_number_already_exists'],
  [4003, 'backend_error.user_already_exists'],
  [4004, 'backend_error.invalid_user'],
  [4006, 'backend_error.password_mismatch'],
  [4007, 'backend_error.attempt_limit_exceeded'],
  [4005, 'backend_error.invalid_user'],
  [4021, 'backend_error.company_does_not_exist'],
  [4022, 'backend_error.invalid_amount'],
  [4023, 'backend_error.invalid_amount'],
  [4031, 'backend_error.users_are_not_friends'],
  [4011, 'backend_error.source_account_does_not_exist'],
  [4012, 'backend_error.destination_account_does_not_exist'],
  [4013, 'backend_error.insufficient_funds_in_the_account'],
  [4014, 'backend_error.wallet_does_not_exist'],
  [4015, 'backend_error.invalid_transaction_status'],
  [4016, 'backend_error.transaction_does_not_exist'],
  [4017, 'backend_error.users_does_not_exist'],
  [4018, 'backend_error.invalid_user'],
  [4019, 'backend_error.invalid_file_format'],
  [4020, 'backend_error.invalid_currency_code'],
  [4061, 'backend_error.currency_not_allowed'],
  [4062, 'backend_error.bank_does_not_exist'],
  [4081, 'backend_error.bank_account_does_not_exist'],
]);


export function getErrorKeyByCode(code: number): string | undefined {
	return errorMap.get(code);
}
